@if (templateModalWindow$ | async; as templateModalWindow) {
  <ng-container *ngTemplateOutlet="templateModalWindow.template; context: templateModalWindow.context"></ng-container>
}
